<template>
  <v-card class="px-3 py-3">
    <BaseDetailTable
        :item-list.sync="itemList"
        :height="height - 180"
        :columns="columnsImport"
        :left-cols="12"
        :show-select="false"
        :single-select="false"
        :item-row-background="importItemRowBackground"
        :hide-default-footer="false"
        :footer-props="{'items-per-page-options': [25, 50, 100, 250]}"
        :items-per-page="100"
        :filter-function="filterFunction"
    >
      <template v-slot:bar>{{ '' }}</template>
      <template v-slot:body.prepend="{ headers }">
        <tr class="drag-header">
          <th class="drag-header"></th>
          <th v-for="(header, index) in headers" class="drag-header" v-if="index >= 1 && index <= 8">
            <v-row v-if="index === 8">
              <v-col cols="4"
                     :draggable="false"
                     @drop="onDropCopy($event, header)"
                     @dragover.prevent
                     @dragenter.prevent
                     class="px-0"
              >
                <v-icon
                    class="px-0 d-flex justify-center"
                >
                  mdi-content-paste
                </v-icon>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="4"
                     :draggable="false"
                     @drop="onDropAdd($event, header)"
                     @dragover.prevent
                     @dragenter.prevent
                     class="px-0"
              >
                <v-icon
                    class="px-0 d-flex justify-center"
                >mdi-page-layout-sidebar-right
                </v-icon>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="4"
                     :draggable="false"
                     @drop="onDropLine($event, header)"
                     @dragover.prevent
                     @dragenter.prevent
                     class="px-0"
              >
                <v-icon
                    class="px-0 d-flex justify-center"
                >mdi-page-layout-footer
                </v-icon>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12"
                     :draggable="false"
                     @drop="onDropCopy($event, header)"
                     @dragover.prevent
                     @dragenter.prevent
                     class="px-0"
              >
                <v-icon
                    class="px-0 d-flex justify-center"
                >mdi-content-paste
                </v-icon>
              </v-col>
            </v-row>
          </th>
          <th v-for="(header, index) in headers" class="drag-header"
              v-if="index > 8"
              :draggable="true"
              @dragstart="onStartDrag($event, header)"
          >
            <v-icon
                class="d-flex justify-center"
            >mdi-swap-horizontal-circle-outline
            </v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:top="paramsDetailTable">
        <v-row class="mt-1">
          <v-btn-toggle
              v-model="grpFilter"
              multiple
              class="ml-3 mr-10 mt-1"
          >
            <v-btn small elevation="2">
              Excluded
              <small class="mt-1">{{ countExcluded() }}</small>
            </v-btn>
            <v-btn small elevation="2">
              Not match
              <small class="mt-1">{{ countNotMatch() }}</small>
            </v-btn>
            <v-btn small elevation="2">
              Match
              <small class="mt-1">{{ countMatch() }}</small>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          <BaseFieldSelect v-model="unit" :items="['mm', 'mil']" class="mr-3" label="Unit"></BaseFieldSelect>
          <BaseFieldString v-model="firstSideName" class="mr-3" label="First side name include"></BaseFieldString>
          <BaseFieldString v-model="secondSideName" class="mr-3" label="Second side name include"></BaseFieldString>
          <v-spacer></v-spacer>
          <v-btn
              small
              class="mx-1 mt-1"
              @click="actionAddClipboard()"
              :loading="loading"
          >
            Paste from clipboard
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.excluded="{item}">
        <v-checkbox v-model="item.excluded" @change="checkColumns"></v-checkbox>
      </template>
      <template v-slot:item.designator="{item}">
        <BaseFieldString v-model="item.designator" :clearable="false" class="text-caption"
                         @input="checkColumns"></BaseFieldString>
      </template>
      <template v-slot:item.layer="{item}">
        <BaseFieldString v-model="item.layer" :clearable="false" class="text-caption"
                         @input="checkColumns"></BaseFieldString>
      </template>
      <template v-slot:item.center_x="{item}">
        <BaseFieldString v-model="item.center_x" class="text-caption" @input="checkColumns"></BaseFieldString>
      </template>
      <template v-slot:item.center_y="{item}">
        <BaseFieldString v-model="item.center_y" class="text-caption" @input="checkColumns"></BaseFieldString>
      </template>
      <template v-slot:item.rotation="{item}">
        <BaseFieldString v-model="item.rotation" class="text-caption" @input="checkColumns"></BaseFieldString>
      </template>
      <template v-slot:item.original_description="{item}">
        <BaseFieldText v-model="item.original_description" :clearable="false" rows="1" auto-grow
                       class="text-caption"></BaseFieldText>
      </template>
      <template v-slot:item.comment="{item}">
        <BaseFieldText v-model="item.comment" :clearable="false" rows="1" auto-grow
                       class="text-caption"></BaseFieldText>
      </template>
      <template v-slot:item.customer_article="{item}">
        <v-text-field v-model="item.customer_article" :clearable="false" outlined
                      :rules="rules64" counter="64" dense class="mt-6"
                      @input="checkColumns"></v-text-field>
      </template>
    </BaseDetailTable>
    <v-card-actions>
      <v-toolbar height="32" elevation="0">
        <v-btn small @click="$emit('cancel'); itemList = []">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
            :disabled="isNotExcludeAllNotMatch"
            small
            @click="onImport()"
        >
          Import
        </v-btn>
      </v-toolbar>
    </v-card-actions>
  </v-card>
</template>

<script>
import {v4 as uuidv4} from "uuid";
// import draggable from "vuedraggable";
// import Sortable from 'sortablejs'
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseDetailTable from "@/components/Base/BaseDetailTable";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";


export default {
  name: 'CoreImportPickPlaceTable',
  props: {
    height: {type: [Number], default: 800},
  },

  components: {
    BaseFieldCheck,
    BaseFieldSelect,
    ConfirmDialog,
    BaseDetailTable,
    BaseFieldNumber,
    BaseFieldString,
    BaseFieldText,
  },

  computed: {},

  methods: {
    rules64: [v => v.length <= 64 || 'Max 64 characters'],
    filterFunction(itemList) {
      // console.log('filterDNPGroup')
      if (!itemList)
        return []
      let result = itemList
      if (this.grpFilter.length === 0)
        return result
      if (this.grpFilter.includes(0))
        result = result.filter(row => row.excluded === true)
      if (this.grpFilter.includes(1) || this.grpFilter.includes(2))
        result = result.filter(row => (row.isSelectable === false && this.grpFilter.includes(1)) ||
            (row.isSelectable === true && this.grpFilter.includes(2)))
      return result
    },
    countExcluded() {
      if (!!this.itemList)
        return this.itemList.filter(row => !row.deleted && row.excluded).length
      else
        return 0
    },
    countNotMatch() {
      if (!!this.itemList)
        return this.itemList.filter(row => !row.deleted && row.isSelectable === false).length
      else
        return 0
    },
    countMatch() {
      if (!!this.itemList)
        return this.itemList.filter(row => !row.deleted && row.isSelectable === true).length
      else
        return 0
    },

    getCellsFromClipboard(readFullText) {
      // console.log('readFullText', readFullText)
      let clipboardArray = []
      if (readFullText.includes('"'))
        for (const [index, row] of readFullText.split('"').entries()) {
          if (index % 2)
            clipboardArray.push(row.replace(/(?<!^)\n/g, "<br>"))
          else
            clipboardArray.push(row)
          // console.log('row', row, index)
        }
      else
        clipboardArray = [readFullText]
      let formatCellText = clipboardArray.join('"')
      // console.log('formatCellText', clipboardArray, formatCellText)
      let resultArray = []
      for (const row of formatCellText.split('\n')) {
        // console.log('row', row)
        const cells = row.split('\t')
        let line = []
        for (let cell of cells) {
          line.push(cell.replaceAll('<br>', '\n').replaceAll('"', ''))
        }
        resultArray.push(line)
      }
      // console.log('resultArray', resultArray)
      return resultArray
    },
    async actionAddClipboard() {
      if (navigator.clipboard == null) {
        this.flagError = true
        this.errorMessage = "This requires a secure origin — either HTTPS or localhost (or disabled by running Chrome with a flag).\n\n" +
            "In chrome://flags, enable 'Insecure origins treated as secure' and give it the origin you want."
        return
      }
      this.loading = true
      const readFullText = await navigator.clipboard.readText()
      // console.log('readFullText', readFullText)
      const clipboardArray = this.getCellsFromClipboard(readFullText)
      // console.log('clipboardArray', clipboardArray)

      for (const lineArray of clipboardArray) {
        // console.log('add row', lineArray)
        let new_bom_sheet = {
          uid: uuidv4(),
          excluded: false,
          designator: null,
          layer: null,
          center_x: null,
          center_y: null,
          rotation: null,
          original_description: null,
          comment: null,
          customer_article: null,
          deleted: false,
        }
        for (const [index, column] of lineArray.entries())
          new_bom_sheet['c' + index] = column
        this.itemList.push(new_bom_sheet)
      }
      this.checkColumns()
      this.loading = false
    },
    importItemRowBackground(item) {
      // console.log('itemRowBackground', item)
      if (!item.isSelectable)
        return 'red lighten-5'
    },
    onStartDrag(event, header) {
      // console.log('onStartDrag', event, event.ctrlKey, header)
      event.dataTransfer.effectAllowed = 'copy'
      event.dataTransfer.setData('header_value', header.value)
      // console.log('onStartDrag end')
    },
    onDropCopy(event, header) {
      this.loading = true
      let transfer_header_value = event.dataTransfer.getData('header_value')
      // console.log('onDrop', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      this.loading = false
      // console.log('onDrop end', this.itemList)
    },
    onDropAdd(event, header) {
      this.loading = true
      let transfer_header_value = event.dataTransfer.getData('header_value')
      // console.log('onDropAdd', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        if (row[header.value] !== null)
          row[header.value] = row[header.value] + ' ' + row[transfer_header_value].replaceAll('\n', ' ')
        else
          row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      this.loading = false
      // console.log('onDrop end', this.itemList)
    },
    onDropLine(event, header) {
      this.loading = true
      let transfer_header_value = event.dataTransfer.getData('header_value')
      // console.log('onDrop', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        if (row[header.value] !== null)
          row[header.value] = row[header.value] + '\n' + row[transfer_header_value]
        else
          row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      this.loading = false
      // console.log('onDrop end', this.itemList)
    },
    onImport() {
      // console.log('onImport', this.itemList)
      this.$emit('import', {
            selectedItems: this.itemList.filter(row => row.deleted === false && row.excluded === false),
            unit: this.unit,
            firstSideName: this.firstSideName,
            secondSideName: this.secondSideName,
          }
      );
      this.itemList = []
      this.unit = 'mm'
      this.firstSideName = 'Top'
      this.secondSideName = 'Bot'
    },
    checkColumns() {
      // console.log('checkColumns', this.itemList)
      for (let row of this.itemList) {
        row.isSelectable =
            !!row.center_x &&
            !!row.center_y &&
            !!row.rotation &&
            !isNaN(parseFloat(row.center_x.replace(/,/g, '.').replace(/[^0-9.]/g, ''))) &&
            !isNaN(parseFloat(row.center_y.replace(/,/g, '.').replace(/[^0-9.]/g, ''))) &&
            !isNaN(parseFloat(row.rotation.replace(/,/g, '.').replace(/[^0-9.]/g, ''))) &&
            !!row.designator
      }
      if (!!this.itemList)
        this.isNotExcludeAllNotMatch = this.itemList.filter(row => !row.deleted && row.isSelectable === false && !row.excluded).length !== 0
      else
        this.isNotExcludeAllNotMatch = true
    },
  },

  async mounted() {
    this.itemList = []

  }
  ,

  data() {
    return {
      loading: false,
      unit: 'mm',
      firstSideName: 'Top',
      secondSideName: 'Bot',
      isNotExcludeAllNotMatch: true,
      grpFilter: [],
      itemList: [],
      columnsImport: [
        {text: 'Excluded', value: 'excluded', sortable: false, filterable: true, divider: false, width: 10},
        {text: 'Designator', value: 'designator', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'Layer', value: 'layer', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'Center X', value: 'center_x', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'Center Y', value: 'center_y', sortable: false, filterable: true, divider: true, width: 100},
        {text: 'Rotation', value: 'rotation', sortable: false, filterable: true, divider: true, width: 100},
        {
          text: 'Description',
          value: 'original_description',
          sortable: false,
          filterable: true,
          divider: true,
          width: 400
        },
        {
          text: 'Customer article',
          value: 'customer_article',
          sortable: false,
          filterable: true,
          divider: true,
          width: 200
        },
        {
          text: 'Comment',
          value: 'comment',
          sortable: false,
          filterable: true,
          divider: true,
          width: 400
        },
        {text: 'C0', value: 'c0', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C1', value: 'c1', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C2', value: 'c2', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C3', value: 'c3', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C4', value: 'c4', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C5', value: 'c5', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C6', value: 'c6', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C7', value: 'c7', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C8', value: 'c8', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C9', value: 'c9', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C10', value: 'c10', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C11', value: 'c11', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C12', value: 'c12', sortable: false, filterable: true, divider: true, width: 20},
      ],
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

.drag-header {
  padding: 0px;
  height: 36px !important;
  border-right: thin solid rgba(0, 0, 0, .12);
  /*border-style: solid;*/
  /*border-width: thin;*/
}
</style>

<i18n>
{
}
</i18n>
